var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheMenuLayout',[_c('BaseSectionHeader',[_vm._v(" Liste des Vidéos disponibles ")]),_c('BaseList',{attrs:{"items":_vm.items}}),(!_vm.items.length)?_c('BaseEmptyState',[_vm._v(" Aucunes Vidéos disponibles ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }